import type { DeckGoalKey } from "../../lib/api.js";

/**
 * The deck goals, operator-facing. Mirrors `DECK_GOALS` in
 * keywords/src/social/deck-goals.ts — the server validates the key, this only
 * names it. The thin-decks endpoint returns the same labels for screens that
 * already fetch it.
 */
export const DECK_GOAL_OPTIONS: { goal: DeckGoalKey; labelHe: string; whenHe: string }[] = [
  { goal: "list", labelHe: "אוסף / רשימה", whenHe: "״אספנו עבורכם״: כל פריט בשקופית משלו" },
  { goal: "explain", labelHe: "הסבר", whenHe: "מה זה ואיך זה עובד" },
  { goal: "myths", labelHe: "מיתוסים ועובדות", whenHe: "כמה מיתוסים, כל אחד בשקופית" },
  { goal: "guide", labelHe: "מדריך צעד־אחר־צעד", whenHe: "כל שלב בשקופית" },
  { goal: "compare", labelHe: "השוואה", whenHe: "X מול Y" },
  { goal: "expect", labelHe: "למה לצפות", whenHe: "מה קורה לפני, במהלך ואחרי" },
];

/** Content slides an operator can ask for: the floor (4) to the most a deck holds (8). */
export const CONTENT_SLIDE_CHOICES = [4, 5, 6, 7, 8] as const;

export const DECK_FORMAT_KEYS = ["carousel", "photo_post", "story"] as const;
export function isDeckFormat(format: string): boolean {
  return (DECK_FORMAT_KEYS as readonly string[]).includes(format);
}

/** Slide roles, operator-facing. `point` is one item of a collection or one step. */
export const ROLE_HE: Record<string, string> = {
  hook: "וו פתיחה",
  answer: "תשובה ישרה",
  distinction: "הבחנה",
  mechanism: "מנגנון",
  point: "פריט",
  numbers: "מספרים",
  warning: "אזהרה",
  myth: "מיתוס",
  expect: "למה לצפות",
  checklist: "צ'קליסט",
  question: "שאלה",
  cta: "קריאה לפעולה",
};
